import React from "react";
import { StyledFooter } from "./style";

const Footer = () => {
  return (
    <StyledFooter>
      © Learning Portal 2.1 BNCC. All rights reserved.
    </StyledFooter>
  );
};

export default Footer;
